import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateLifecycle } from '../../../../state';
import { shouldCommitDateInputChange } from '../../../../../../utils/DateConversions';

const EndDateEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    if (!shouldCommitDateInputChange(raw, currentRecurringTask?.endDate)) return;
    dispatch(updateLifecycle({ endDate: raw || undefined }));
  };

  return (
    <TextField
      label="End Date (Optional)"
      value={currentRecurringTask?.endDate || ''}
      onChange={handleChange}
      size="small"
      type="date"
      InputLabelProps={{ shrink: true }}
      sx={{ minWidth: 180 }}
      helperText="Leave empty for no end date"
    />
  );
};

export default EndDateEdit;
